import { Injectable } from '@angular/core';
const FileSaver = require('file-saver');
import * as XLSX from "xlsx";
import { DateHelper } from "../bundles/helpers.bundle";

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable()
export class ExportService {

    constructor() { }

  public exportAsExcelFile(json: any[], excelFileName: string): void {



    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);

    Object.keys(worksheet).forEach(function (s) {
      if (worksheet[s].t === 'n') {
        worksheet[s].z = '0';
        worksheet[s].t = 's';
      }      
    });

    var rowNum;
    var colNum;
    var range = XLSX.utils.decode_range(worksheet['!ref']);
    for (rowNum = range.s.r; rowNum <= range.e.r; rowNum++) {
      if (rowNum === 0) {
        for (colNum = range.s.c; colNum <= range.e.c; colNum++) {
          var nextCell = worksheet[
            XLSX.utils.encode_cell({ r: rowNum, c: colNum })
          ];
          nextCell.v = nextCell.v.toUpperCase();
        }
      }      
    }

    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }


  public exportAsExcelFileQip(json: any[], excelFileName: string): void {

    let Heading = ['M_ID', 'M_YR', 'HOSP_ID', 'M_PROV', 'M_NBR1', 'M_NBR2', 'M_NBR3', 'M_NBR4', 'M_LNAME', 'M_FNAME', 'M_MI', 
      'M_DOB', 'M_GENDER', 'M_SAMP', 'M_ELEMT', 'SVC_DT', 'ADMT_DT', 'DICH_DT', 'BP_TM', 'BG_TM', 'ED_TM', 'RES_VAL', 'CODE_VAL', 
      'RES_VALP', 'DEPS_T1', 'DEPS_O1', 'DEPS_S1', 'DEPS_I1', 'TOBA_T', 'TOBA_S', 'TOBA_I', 'ALCS_T', 'ALCS_S', 'ALCS_I', 'DRUG_T', 
      'DRUG_S', 'DRUG_I', 'INCL_T', 'INCL_S', 'INCL_I', 'NULLIP', 'VERTEX', 'DEPS_T2', 'DEPS_O2', 'DEPS_S2', 'DEPS_I2', 'BP_SYST', 
      'BP_DIAS', 'ED_OTHTX', 'DMODE', 'CTMS_I', 'CTMS_E', 'CTMS_S', 'SDOH_T', 'SDOH_E', 'SDOH_R1', 'SDOH_I1', 'SDOH_R2', 'SDOH_I2', 
      'SDOH_R3', 'SDOH_I3', 'SDOH_R4', 'SDOH_I4', 'SDOH_R5', 'SDOH_I5', 'RACE', 'ETHNIC', 'EOF_ID'];

    let newlist = [];
    let item;
    json.forEach((row) => {
      item = {};
      for (let i = 0; i < Heading.length; i++) {       
        item[Heading[i]] = row[Heading[i].toLowerCase()];
      }
      newlist.push(item);
    });

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(newlist);
    Object.keys(worksheet).forEach(function (s) {
      if (worksheet[s].t === 'n') {
        worksheet[s].z = '0';
        worksheet[s].t = 's';
      }
    });

    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }
  

    private saveAsExcelFile(buffer: any, fileName: string): void {
        const data: Blob = new Blob([buffer], {
            type: EXCEL_TYPE
        });

        let date = new Date();
        const resultDate = DateHelper.getStringDate_MMDDYYYY(date);
       
        FileSaver.saveAs(data, fileName + '_' + resultDate + EXCEL_EXTENSION);
    }

}
